module.exports = __webpack_public_path__ + "images/application/templates/reset-password@2x-300f085f.png";